$(document).ready(function () {
  $(
    "button.live-search-button.mdc-ripple-surface.mdc-ripple-upgraded.custom_sercah"
  ).on("click", function () {
    setTimeout(function () {
      $(
        "input.form-field-input.live-search-form-field.serachinputactive.inputactive"
      ).focus();
      console.log("focus");
    }, 300);
  });
  // mobile
  $(
    "button.live-search-button.mdc-ripple-surface.mdc-ripple-upgraded.for_mobile_csrty"
  ).on("click", function () {
    setTimeout(function () {
      $(
        "input.form-field-input.live-search-form-field.for_moble_csrt.serachinputactive.inputactive"
      ).focus();
      console.log("focus");
    }, 300);
  });
  // for serach
  $(
    "button.live-search-button.mdc-ripple-surface.mdc-ripple-upgraded.custom_sercah"
  ).on("click", function () {
    $(".nav_center_nikki").addClass("serachactive");
    $("input.form-field-input.live-search-form-field").addClass(
      "serachinputactive"
    );
    $("form.live-search-form.form-fields-inline input").addClass("inputactive");
    $("button.live-search-takeover-cancel").addClass("cancelactive");
    $(".live-search.hover_unique_csrty").addClass("liveserachactive");
  });
  $("button.live-search-takeover-cancel").on("click", function () {
    $("form.live-search-form.form-fields-inline input").removeClass(
      "inputactive"
    );
    $("button.live-search-takeover-cancel").removeClass("cancelactive");
    $(".nav_center_nikki").removeClass("serachactive");
    $("input.form-field-input.live-search-form-field").removeClass(
      "serachinputactive"
    );
    $(".live-search.hover_unique_csrty + .form-field.no-label").removeClass(
      "input_active"
    );
    $(".live-search.hover_unique_csrty").removeClass("liveserachactive");
  });

  // for mobile
  $(
    "button.live-search-button.mdc-ripple-surface.mdc-ripple-upgraded.for_mobile_csrty"
  ).on("click", function () {
    $("input.form-field-input.live-search-form-field.for_moble_csrt").addClass(
      "serachinputactive"
    );
    $(
      "form.live-search-form.form-fields-inline.for_mobile_csrt input"
    ).addClass("inputactive");
    $("button.live-search-takeover-cancel.for_mobile_csrt").addClass(
      "cancelactive"
    );
    $(".live-search.hover_unique_csrty.for_mobile_csrty").addClass(
      "liveserachactive"
    );
  });

  // end for serach

  $("input.form-field-input.live-search-form-field.serachinputactive").keypress(
    function (event) {
      if (event.which === 13) {
        $(
          "button.live-search-button.serach_ctyu.mdc-ripple-surface.mdc-ripple-upgraded"
        ).trigger("click");
      }
    }
  );

  $(".custom-model-main").removeClass("model-open");
  // for collection page_ variant
  $(".productitem--swatches").mouseenter(function () {
    $(this)
      .children("form.productitem--swatches-container")
      .addClass("Show_variant_color");
  });
  $(".productitem--swatches").mouseleave(function () {
    $(this)
      .children("form.productitem--swatches-container")
      .removeClass("Show_variant_color");
  });

  // for desks collection

  $(".variant_field_csrty").mouseenter(function () {
    $(this)
      .children(
        "fieldset.options-selection__swatches.options-selection__swatches--color_swatch"
      )
      .addClass("desk_count_active");
  });

  $(".variant_field_csrty").mouseleave(function () {
    $(this)
      .children(
        "fieldset.options-selection__swatches.options-selection__swatches--color_swatch"
      )
      .removeClass("desk_count_active");
  });

  // end for collection page_variant
  $(
    ".product-form__action-wrapper.own_product button.product-form--atc-button.own_addtoCart.mdc-ripple-surface.mdc-ripple-upgraded"
  ).css("max-width", "100%");
  // bundle
  $(".bundle-sec .bundle-grid").on("click", function () {
    $(this).toggleClass("gridactive");

    // Get all elements with 'product-price' attribute inside .bundle-sec .bundle-grid with class 'gridactive'
    var selectedProducts = $(".bundle-sec .bundle-grid.gridactive").find(
      "[product-price]"
    );

    // Initialize total price
    var totalPrice = 0;

    // Iterate over each selected product
    selectedProducts.each(function () {
      var product_price = $(this).attr("product-price");
      var product_pricewithoutdollar = parseFloat(
        product_price.replace("$", "")
      );

      // Add product price to total price
      totalPrice += product_pricewithoutdollar;
    });

    // Set total price after a timeout to ensure all elements are updated
    setTimeout(function () {
      $("span.price_cwithoutut").text("$" + totalPrice.toFixed(2)); // Display result with 2 decimal places
    }, 500);
    // for delpricemax

    var selectedProductsdel = $(".bundle-sec .bundle-grid.gridactive").find(
      "[product-delprice]"
    );
    var totalPricedel = 0;

    // Iterate over each selected product
    selectedProductsdel.each(function () {
      var product_pricedel = $(this).attr("product-delprice");
      var product_pricewithoutdollardel = parseFloat(
        product_pricedel.replace("$", "")
      );

      // Add product price to total price
      totalPricedel += product_pricewithoutdollardel;
    });
   

    // Set total price after a timeout to ensure all elements are updated
    setTimeout(function () {
      $(".total_price_bundle_csrty span.compare_price_cut del").text(
        "$" + totalPricedel.toFixed(2)
      ); // Display result with 2 decimal places
    }, 500);
  });

  $(document).on("click", "a.addto_cart_bundle_csrt:not('.bundle-quick-view')", function () {
    let bundleIds = [];
    $(".bundle-sec .bundle-grid.gridactive")
      .find("[bundle-id]")
      .each(function () {
        let bundle_id = $(this).attr("bundle-id");
        bundleIds.push(bundle_id);
      });

    // Function to add product to cart
    function addToCart(bundle_id) {
      if($(`[bundle-id='${bundle_id}']`).closest('.bundle-grid-item').find('.content_icon_bundle').attr("product-quantity")){
         var quantity = Number($(`[bundle-id='${bundle_id}']`).closest('.bundle-grid-item').find('.content_icon_bundle').attr("product-quantity"));
      }else{
         var quantity = 1;
      }
     
      
      return new Promise((resolve, reject) => {
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            quantity: quantity,
            id: bundle_id,
          },
          dataType: "json",
          success: function (response) {
            console.log("Product added to cart:", response);
            resolve(); // Resolve the promise when the request is successful
          },
          error: function (error) {
            console.error("Error adding product to cart:", error);
            reject(error); // Reject the promise if there's an error
          },
        });
      });
    }

    // Sequentially add products to cart
    bundleIds.reduce((promiseChain, bundle_id, index) => {
      return promiseChain.then(() => {
        // Check if this is the last product
        if (index === bundleIds.length - 1) {
          // Redirect to cart page after adding the last product
          return addToCart(bundle_id).then(() => {
            window.location.href = "/cart";
          });
        } else {
          return addToCart(bundle_id);
        }
      });
    }, Promise.resolve());
  });

  // end bundle
  // for bestseller seelcting
  $(
    ".demo-slider-inner li.item .arrivals_main .arrivals_info .product_info .variant_csrty label"
  ).on("click", function () {
    $(this).siblings().removeClass("activeCOLOR");
    $(this).addClass("activeCOLOR");
  });

  // collection page add to card
  $(".productitem--swatches-container label").on("click", function () {
    // Remove 'selected' class from all labels
    $(".productitem--swatches-container label").removeClass("selected");
    // Add 'not-selected' class to all labels
    $(".productitem--swatches-container label").addClass("not-selected");
    // Add 'selected' class to the clicked label
    $(this).addClass("selected");
    // Remove 'not-selected' class from the clicked label
    $(this).removeClass("not-selected");
  });
  $(".accessiors_btn_add").on("click", function () {
    var idvarinat = $(
      "form.productitem--swatches-container label.selected input"
    ).attr("id-variant");
    console.log(idvarinat);
    const quantity = 1;
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: quantity,
        id: idvarinat,
      },
      dataType: "json",
      success: function (response) {
        console.log("Product added to cart:", response);
        window.location.href = "/cart";
      },
      error: function (error) {
        console.error("Error adding product to cart:", error);
      },
    });
  });
  $(".butn_quickadd").click(function () {
    $(this).addClass("adding");
    var variant_id = $(this).attr("data-variant-id");
    console.log(variant_id);
    const quantity = 1;
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: quantity,
        id: variant_id,
      },
      dataType: "json",
      success: function (response) {
        console.log("Product added to cart:", response);
        window.location.href = "/cart";
      },
      error: function (error) {
        console.error("Error adding product to cart:", error);
      },
    });
  });
  // collection page review product
  $(".quickshop-button").click(function () {
    // Remove 'activeli' class from all list items
    $(".productgrid--item").removeClass("activeli");
    // Add 'activeli' class to the parent list item of the clicked button
    $(".quick_innfoormtion").removeClass("closed");
    $(this).closest(".productgrid--item").addClass("activeli");
    $("body").addClass("quick_active");
  });

  $(".modal-close").click(function () {
    // Add class to the parent element
    $(".quick_innfoormtion").addClass("closed");
    $("body").removeClass("quick_active");
  });

  // for mobile click add class
  $(".mobile-nav-content ul.navmenu.navmenu-depth-1 li.navmenu-item").click(
    function () {
      // Remove the 'active' class from all sibling elements with class 'navmenu-item'
      $(this).siblings().removeClass("mobileactive");
      $(this).siblings().addClass("mobileinactive");
      // Add the 'active' class to the clicked element
      $(this).addClass("mobileactive");
      $(this).removeClass("mobileinactive");
    }
  );

  // on close remove class
  $("a.mobile-nav-close").on("click", function () {
    $(
      ".mobile-nav-content ul.navmenu.navmenu-depth-1 li.navmenu-item"
    ).removeClass("mobileinactive");
    $(
      ".mobile-nav-content ul.navmenu.navmenu-depth-1 li.navmenu-item"
    ).removeClass("mobileactive");
  });

  $(
    ".nav_center_nikki nav.site-navigation .navmenu li.navmenu-meganav__item-parent"
  ).hover(
    function () {
      $(this).addClass("hover-class");
      $(".navmenu li.navmenu-meganav__item-parent")
        .not($(this))
        .addClass("other-class");
    },
    function () {
      $(this).removeClass("hover-class");
      $(".navmenu li.navmenu-meganav__item-parent")
        .not($(this))
        .removeClass("other-class");
    }
  );
  // for product mobiel

  $("fieldset.for_mobile_csrty .for_mobile_option").click(function () {
    // Remove "active" class from all fieldsets with the class "for_mobile_csrty" except the clicked one
    $("fieldset.for_mobile_csrty .for_mobile_option")
      .not(this)
      .removeClass("active");
    $("fieldset.for_mobile_csrty .for_mobile_option")
      .not(this)
      .prev(".options-selection__option-values")
      .removeClass("on_active");
    // Toggle "active" class on the clicked fieldset
    $(this).toggleClass("active");
    $(".custom-model-main").toggleClass("active");
    $(this).prev(".options-selection__option-values").toggleClass("on_active");
    if ($("body").find("div.on_active").length > 0) {
      // If there's any div with class "on_active", add "active" class to the model
      $(".custom-model-main.model-open").addClass("active");
      $("body").addClass("unique_scroll");
    } else {
      // If not, remove "active" class from the model
      $(".custom-model-main.model-open").removeClass("active");
      $("body").removeClass("unique_scroll");
    }
  });
  //  for frame only
  $(".for_mobile_option.val__frame .icon_mobile").on("click", function () {
    if ($(this).hasClass("frame_active")) {
      $(
        ".options-selection__option-values.unique_csrtframe.for.mobile_csdrt.on_active"
      ).addClass("farmeactive");
    } else {
      $(
        ".options-selection__option-values.unique_csrtframe.for.mobile_csdrt.on_active"
      ).removeClass("farmeactive");
      $(".for_mobile_option.val__frame").trigger("click");
      console.log(
        "The element does not have the frame_active class. Removed active class from custom-model-main."
      );
    }
  });
  $(".for_mobile_option.val__frame span.icon_mobile").on("click", function () {
    $(this).toggleClass("frame_active");
    $(".custom-model-main.model-open").toggleClass("frame_active_values");
    // $('.custom-model-main.model-open').toggleClass("active");

    $("fieldset.for_mobile_csrty .for_mobile_option")
      .not(this)
      .removeClass("active");
    $("fieldset.for_mobile_csrty .for_mobile_option")
      .not(this)
      .prev(".options-selection__option-values")
      .removeClass("on_active");

    // Check if any div within the body has the class "on_active"
    if ($("body").find("div.on_active").length > 0) {
      // If there's any div with class "on_active", add "active" class to the model
      $(".custom-model-main.model-open").addClass("active");
    } else {
      // If not, remove "active" class from the model
      $(".custom-model-main.model-open").removeClass("active");
    }
  });


  const changeActiveImages = () => {
  $(".product-change-image").each(function () {
        const parentElement = $(this);
        var variantId = parentElement.find(".variant-selection.normal_form").attr("variant");
   
        const variantImage = parentElement.find(`.variant-selection.normal_form select option[value="${variantId}"]`).attr("data-variant-image");
        const variantPrice = parentElement.find(`.variant-selection.normal_form select option[value="${variantId}"]`).attr("data-variant-price");
        const variantAvailable = parentElement.find(`.variant-selection.normal_form select option[value="${variantId}"]`).attr('disabled') ? true : false;
    

        variantAvailable ? $('.product-form--atc-button').addClass('popup') : $('.product-form--atc-button').removeClass('popup')
        variantAvailable ? $('.product-form--atc-button .atc-button--text').text('Contact Us') : $('.product-form--atc-button .atc-button--text').text('Add to Cart')
        const blocks = document.querySelectorAll('.product-form__action-wrapper-main-text');
        let found = false;

        blocks.forEach(block => {
          const shipId = block.getAttribute('data-variant-ship-id');
          if (shipId === variantId) {
            block.style.display = 'flex';
            found = true;
          } else {
            block.style.display = 'none';
          }
        });

         if (!found && blocks.length > 0) {
          blocks.forEach((block, index) => {
            block.style.display = index === 0 ? 'flex' : 'none';
          });
       }


    
       
        const selectedMedia = parentElement.find(`.gallery-navigation--scroller img[src="${variantImage}"]`).closest(".cst-media-sec");
    
        console.log(selectedMedia)
    
        if(variantPrice){
        document.querySelector('.product-pricing .price__current .money').innerHTML = `$${(variantPrice / 100).toFixed(2)}`
        }
    
        if (selectedMedia.length) {
          const allMedia = parentElement.find(".gallery-navigation--scroller .cst-media-sec");
          console.log(allMedia);
          allMedia.hide(); 
    
          selectedMedia.show(); 
          
          let currentElement = selectedMedia;
          var showImages = document.querySelector('[data-collection]').getAttribute('data-collection') == 'Accessories' ? 3 : 6;
          if(document.querySelector('[data-image-count]') && document.querySelector('[data-image-count]').getAttribute('data-image-count') != 0){
            showImages =  document.querySelector('[data-image-count]').getAttribute('data-image-count')
          }
          for (let i = 1; i < showImages; i++) {
            currentElement = currentElement.next();
            if (currentElement.length) {
              currentElement.show(); 
            } else {
              break;
            }
          }
    
    
      
    
        }
  
  });
};


    const mobileSlider = new Swiper('.thumnailslider_for_mobile', {
  
      pagination: {
        el: '.swiper-pagination',
      },
     
    });

    const changeActiveMobileImages = () => {
       $(".product__container").each(function () {
        const parentElement = $(this);
        const variantId = $(".product-change-image").find(".variant-selection.normal_form").attr("variant");
        const variantImage = $(".product-change-image").find(`.variant-selection.normal_form select option[value="${variantId}"]`).attr("data-variant-image");
    
        const selectedMedia = parentElement.find(`.thumnailslider_for_mobile img[src="${variantImage}"]`).closest(".swiper-slide")
   console.log(selectedMedia)
        if (selectedMedia.length) {
          const allMedia = parentElement.find(".thumnailslider_for_mobile .swiper-slide");

          console.log(variantImage)
          
          allMedia.hide(); // Скрываем все изображения в текущем родителе
    
          selectedMedia.show(); // Показываем выбранное изображение

         

        var showImages = document.querySelector('[data-collection]').getAttribute('data-collection') == 'Accessories' ? 3 : 5;
          if(document.querySelector('[data-image-count]') && document.querySelector('[data-image-count]').getAttribute('data-image-count') != 0){
            showImages =  document.querySelector('[data-image-count]').getAttribute('data-image-count') 
          }
          let currentElement = selectedMedia;
          for (let i = 1; i < showImages; i++) {
            currentElement = currentElement.next();
            if (currentElement.length) {
              currentElement.show(); // Показываем следующие 5 элементов
            } else {
              break;
            }
          }
    
         
          
    
    
    
        }
    });
        console.log(mobileSlider);
      mobileSlider.update();
      mobileSlider.slideTo(0);
    }
          
 

 


  
  


  

  


  $(document).ready(function () {

   $('.product--section .quick_innfoormtion').each(function () {
    $(this).find('.options-selection__option-values').each(function () {
      const $firstAvailable = $(this).find('input[type="radio"]:enabled').first();
      if ($firstAvailable.length) {
        $firstAvailable.prop('checked', true).trigger('change');
      }
    });
  });

    
    changeActiveImages();
    changeActiveMobileImages();
    
  })
  // for color
  $("label.options-selection__option-value-label.Color").on(
    "click",
    function () {
     
      setTimeout(function () {
        var color = $(".for_mobile_option.val__Color")
          .prev(
            ".options-selection__option-values.unique_csrtColor.for.mobile_csdrt"
          )
          .attr("data-variant-option-chosen-value");
        console.log(color);
        $(".for_mobile_option.val__Color span.color_seleted label").css(
          "background-color",
          color
        );
        $(".for_mobile_option.val__Color span.color_seleted label").text(color);


      }, 500);
    }
  );


$("[data-variant-option-value]").change(function () {
  setTimeout(changeActiveImages, 300);
  setTimeout(changeActiveMobileImages, 300);
});

 

  
  // frame
  $("label.options-selection__option-value-label.frame").on(
    "click",
    function () {
      console.log(123123);
      setTimeout(function () {
        var frame = $(".for_mobile_option.val__frame")
          .prev(
            ".options-selection__option-values.unique_csrtframe.for.mobile_csdrt"
          )
          .attr("data-variant-option-chosen-value");
        console.log("frame" + frame);
        $(".for_mobile_option.val__frame span.color_seleted label").css(
          "background-color",
          frame
        );
        $(".for_mobile_option.val__frame span.color_seleted label").text(frame);

      }, 500);
    }
  );

  // end mobile
  $("button.site-header-menu-toggle.test_68").on("click", function () {
    $(".mobile-nav-panel").addClass("allow-scroll-while-locked");
    $("html.js.has-touch").addClass("scroll-locked");
    $("div#site-mobile-nav").attr("data-open", "true");
    $(".mobile-nav-panel").attr("data-animation-state", "open");
  });
  $("a.mobile-nav-close").on("click", function () {
    $(".mobile-nav-panel").removeClass("allow-scroll-while-locked");
    $("html.js.has-touch").removeClass("scroll-locked");
    $("div#site-mobile-nav").attr("data-open", "false");
    $(".mobile-nav-panel").attr("data-animation-state", "closed");
  });
  $(".currentprice_is_csrty p:last-child").hide();
  // above 5
  $(".details-wrapper details summary").on("click", function () {
    console.log("run");
    if ($(".details-wrapper details").attr("open") !== undefined) {
      var screenWidth = $(window).width();
      console.log("has attr");

      $(".product-form__action-wrapper.own_product").removeClass("disable");
      if (screenWidth < 991) {
        console.log("Screen width is under 991 pixels");
        $("#stop_scroll").css("margin-top", "0px");
      } else {
        $("#stop_scroll").css("margin-top", "0px");
      }
    } else {
      var screenWidth = $(window).width();
      console.log("not attr");

      $(".product-form__action-wrapper.own_product").addClass("disable");
      if (screenWidth < 991) {
        console.log("Screen width is under 991 pixels 1111");
        $("#stop_scroll").css("margin-top", "0px");
      } else {
        console.log("Screen width is more 991 pixels 11112");
        $("#stop_scroll").css("margin-top", "160px");
      }
    }
  });

  // end above 5
  // start add on
  $(".add_icon").on("click", function () {
    const container = $(this).closest(".product_infor_add_on");
    const addIcon = container.find(".add_icon");
    const addDone = container.find(".add_done");

    // Очистка
    addIcon.removeClass("Add_icon_active").show();
    $(".add_done").removeClass("adddone_active");

    // Установка активного состояния
    $(this).addClass("Add_icon_active").hide();
    addDone.addClass("adddone_active");

    // Добавляем продукт
    addProduct(container);
  });

  $("span.removed").on("click", function () {
    const container = $(this).closest(".product_infor_add_on");
    const addIcon = container.find(".add_icon");
    const addDone = container.find(".add_done");

    addIcon.show().removeClass("Add_icon_active");
    addDone.removeClass("adddone_active");

    // Удаление продукта
    removeProduct(container);
  });

  //   $(".product_infor_add_on .add_icon").on("click", function () {
  //     // Find the associated input element
  //     var productAddonInput = $(this).siblings("input.product_Addon");

  //     // Trigger click event only for the associated input element
  //     productAddonInput.trigger("click");
  // });

  // $("input.product_Addon").on("change", function () {

  //     if ($(this).prop("checked")) {
  //         addProduct();
  //     } else {
  //         removeproduct();
  //     }
  // });

  function addProduct(container) {
  const productid = container.find("input.product_Addon").attr("variant-id");
  const quantity = 1;

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      quantity: quantity,
      id: productid,
    },
    dataType: "json",
    success: function (response) {
      console.log("Product added to cart:", response);
    },
    error: function (error) {
      console.error("Error adding product to cart:", error);
    },
  });
}

function removeProduct(container) {
  const productid = container.find("input.product_Addon").attr("variant-id");

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      quantity: 0,
      id: productid,
    },
    success: function (cart) {
      console.log("Product removed from cart:", cart);
    },
    error: function (error) {
      console.error("Error removing product from cart:", error);
    },
  });
}

  // product page quantity
  $(document).ready(function () {
  // Проверяем, находимся ли мы на странице продукта
  if ($("body").hasClass("template-product")) { 
    const quantityInput = $("input.quantity-selector__input");
    const minusButton = $(".quantity-selector__button--minus");

    // Функция для управления классом "disabled"
    function toggleMinusButtonState(quantity) {
      if (quantity > 1) {
        minusButton.closest(".quantity-selector__button-wrapper").removeClass("quantity-selector__button-wrapper--disabled");
      } else {
        minusButton.closest(".quantity-selector__button-wrapper").addClass("quantity-selector__button-wrapper--disabled");
      }
    }

    // Кнопка "+"
    $(".quantity-selector__button--plus").on("click", function () {
      let currentQuantity = parseInt(quantityInput.val()) || 1;
      currentQuantity++;
      quantityInput.val(currentQuantity).trigger("input"); // Обновляем значение и триггерим событие
      toggleMinusButtonState(currentQuantity); // Обновляем состояние кнопки минус
    });

    // Кнопка "-"
    $(".quantity-selector__button--minus").on("click", function () {
      let currentQuantity = parseInt(quantityInput.val()) || 1;
      if (currentQuantity > 1) {
        currentQuantity--;
        quantityInput.val(currentQuantity).trigger("input"); // Обновляем значение и триггерим событие
        toggleMinusButtonState(currentQuantity); // Обновляем состояние кнопки минус
      }
    });

    // Начальная проверка, если вдруг начальное количество уже больше 1
    toggleMinusButtonState(parseInt(quantityInput.val()) || 1);
  }
});

  // for popup header
  $(".Click-here").on("click", function () {
    $(".custom-model-main").addClass("model-open");
  });
  $(".close-btn, .bg-overlay").click(function () {
    $(".custom-model-main").removeClass("model-open");
  });

  // Function to check if a specific collection slider is visible
  function isCollectionSliderVisible() {
    var collectionSlider = $(".Collection_slider_unique");
    var scrollPosition = $(window).scrollTop();
    var elementPosition = collectionSlider.offset().top;

    return elementPosition < scrollPosition + 1000; // Check if scroll position is 200px below the element position
  }

  function showAlerts() {
    if (isCollectionSliderVisible()) {
      // Trigger click event for .Click-here
      $(".Click-here").trigger("click");
    } else {
      // Trigger click event for .close-btn
      $(".close-btn").trigger("click");
    }
  }

  $(window).scroll(function () {
    showAlerts();
  });

  // for sticky side bar
  $(function () {
    var top =
      $("#sidebar").offset().top -
      parseFloat($("#sidebar").css("marginTop").replace(/auto/, 0));
    var footTop =
      $("#stop_scroll").offset().top -
      parseFloat($("#stop_scroll").css("marginTop").replace(/auto/, 0));

    var maxY = footTop - $("#sidebar").outerHeight();

    $(window).scroll(function (evt) {
      var y = $(this).scrollTop();
      var windowWidth = $(window).width(); // Get window width
      var mobileBreakpoint = 767; // Define your mobile breakpoint here

      if (windowWidth >= mobileBreakpoint) {
        // Check if screen width is greater than or equal to mobile breakpoint

        if (y > top) {
          if (y < maxY) {
            // $('#sidebar').addClass('fixed').removeAttr('style');
          } else {
            // $('#sidebar').removeClass('fixed').css({
            //     position: 'relative',
            //     top: (maxY - top) + 'px'
            // });
          }
        } else {
          // $('#sidebar').removeClass('fixed');
        }
      } else {
        // $('#sidebar').removeClass('fixed'); // Remove fixed class for mobile
      }
    });
  });

  // Function to check if the screen width indicates a mobile device

  function isMobile() {
    return window.innerWidth <= 1024; // You can adjust this threshold based on your needs
  }

  // Your JavaScript code to run on mobile
  if (isMobile()) {
    // Your mobile-specific code goes here
    console.log("Running JavaScript code for mobile devices");

    $(".product-main").attr("id", "");
    $(".product-details").attr("id", "");
  }

  $(".product-form__action-wrapper.own_product");
});

document.addEventListener("DOMContentLoaded", function () {
  const priceElement = document.querySelector(".price_csrty .money"); // Спан с ценой
  const quantityInput = document.querySelector("input.quantity-selector__input"); // Поле количества
  const variantSelector = $(".variant-selection.normal_form")[1]; // Выбор варианта

  if (!priceElement || !variantSelector || !quantityInput) {
    return;
  }

  // Функция для обновления цены
  function updatePrice() {

    let variantId;
    let selectedOption = null;
    
    if (typeof jQuery !== "undefined") {
      variantId = $(".variant-selection.normal_form")[1].getAttribute("variant");
      selectedOption = $(`.variant-selection.normal_form select option[value="${variantId}"]`).get(0);;
    } else {
      const variantElement = document.querySelector(".variant-selection.normal_form");
      variantId = variantElement ? variantElement.getAttribute("variant") : null;
    }
    
    
    // Извлекаем текстовое содержимое option
    const optionText = selectedOption.textContent || selectedOption.innerText;
    
    // Используем регулярное выражение для извлечения числа после "$"
    const priceMatch = optionText.match(/\$([\d,\.]+)/);
    let variantPrice = priceMatch ? parseFloat(priceMatch[1].replace(',', '')) : null;
    

    if (isNaN(variantPrice)) {
      return; // Если цена невалидна, выходим
    }

    let quantity = parseInt(quantityInput.value) || 1;

    let finalPrice = variantPrice * quantity; // Умножаем цену на количество

    // Получаем скидку от количества
    let discount = getBulkDiscount(quantity, variantPrice);

finalPrice -= discount;

const formattedFinalPrice = finalPrice.toFixed(2);
const formattedDiscount = discount.toFixed(2);

// Обновляем цену в интерфейсе
priceElement.innerHTML = `$${formattedFinalPrice}`;

if (discount > 0) {
  let discountElement = priceElement.nextElementSibling;

  if (discountElement && discountElement.classList.contains("save")) {
    discountElement.innerHTML = ` save $${formattedDiscount}`;
  } else {
    discountElement = document.createElement("span");
    discountElement.classList.add("save");
    discountElement.innerHTML = ` save $${formattedDiscount}`;
    priceElement.after(discountElement);
  }
} else {
  const saveElement = document.querySelector('.currentprice_is_csrty .save');
  if (saveElement) {
    saveElement.remove();
  }
}


    
  }

  function getBulkDiscount(quantity, basePrice) {
      let table = document.querySelector('.bulk-discounts-dropdown__table');
  
      // Удаляем все возможные классы перед добавлением нового
      table.classList.remove('q5', 'q10', 'q20');
  
      if (quantity >= 20) {
          table.classList.add('q20');
          return basePrice * 0.20 * quantity; // 20% скидка
      } 
      if (quantity >= 10) {
          table.classList.add('q10');
          return basePrice * 0.10 * quantity; // 10% скидка
      } 
      if (quantity >= 5) {
          table.classList.add('q5');
          return basePrice * 0.05 * quantity; // 5% скидка
      } 
  
      return 0; // Без скидки
  }


  // Навешиваем события
  variantSelector.addEventListener("change", updatePrice);
  quantityInput.addEventListener("input", updatePrice);

  // Обработчики кликов на кнопки + и -
  document.querySelectorAll(".quantity-selector__button").forEach(button => {
    button.addEventListener("click", function () {
      setTimeout(() => {
        updatePrice(); // Даем время обновиться количеству и пересчитываем цену
      }, 100);
    });
  });

  updatePrice(); // Вызываем при загрузке страницы
});

// async function queryDiscount() {
//     const response = await fetch(window.Shopify.routes.root + 'admin/price_rules.json');
//     const rules = await response.json();
//     console.log('rules', rules)
// };
// queryDiscount();
